"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryFullName = exports.arbitraryName = exports.arbitraryUserHandle = void 0;
exports.arbitraryUser = arbitraryUser;
exports.arbitraryNonAnonymousUser = arbitraryNonAnonymousUser;
exports.arbitraryAnonymousUser = arbitraryAnonymousUser;
const tslib_1 = require("tslib");
const constants_1 = require("@buildwithflux/constants");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const plan_1 = require("../../src/plan");
const identifier_1 = require("./identifier");
const payment_1 = require("./payment");
const social_1 = require("./social");
/**
 * Handles can be any old value.  At the moment we're doing something kinda weird and using hex
 * strings, but it's just because it's easy.
 *
 * Note: be careful when using this without clearing up state between test runs, or when using getOneSample(), because
 * it often produces non-unique handles (e.g. the string "a")
 */
exports.arbitraryUserHandle = fast_check_1.default.hexaString({ minLength: 8, maxLength: 20 });
exports.arbitraryName = fast_check_1.default.constantFrom("Archer", "Beckett", "Blair", "Cameron", "Cooper", "Dylan", "Flynn", "Graham", "Harper", "Harrison", "Hudson", "Lincoln", "Logan", "Mason", "Murphy", "Quinn", "Riley", "Sawyer", "Sloane");
exports.arbitraryFullName = fast_check_1.default
    .array(exports.arbitraryName, { minLength: 2, maxLength: 3 })
    .map((cs) => cs.join(" "));
/**
 * Creates a completely arbitrary user.  May or may not be the arbitrary user.
 */
function arbitraryUser(constraints = {}) {
    // If we are provided both a userUid and isAnonymous constraint, this is a logical contradiction unless they match
    if (constraints.isAnonymous !== undefined && constraints.userUid) {
        if ((constraints.isAnonymous && constraints.userUid !== constants_1.ANON_ROLE_UID) ||
            (!constraints.isAnonymous && constraints.userUid === constants_1.ANON_ROLE_UID)) {
            throw new Error("isAnonymous and userUid constraints are logically contradictory");
        }
    }
    const isAnonymousConstraint = constraints.userUid
        ? fast_check_1.default.constant(constraints.userUid === constants_1.ANON_ROLE_UID)
        : constraints.isAnonymous !== undefined
            ? fast_check_1.default.constant(constraints.isAnonymous)
            : fast_check_1.default.boolean();
    const userUidConstraint = isAnonymousConstraint.chain((isAnonymous) => isAnonymous
        ? fast_check_1.default.constant(constants_1.ANON_ROLE_UID)
        : constraints.userUid
            ? fast_check_1.default.constant(constraints.userUid)
            : identifier_1.arbitraryNonAnonymousUserUid);
    return fast_check_1.default
        .tuple(userUidConstraint, isAnonymousConstraint, constraints.userHandle ? fast_check_1.default.constant(constraints.userHandle) : exports.arbitraryUserHandle, constraints.fullName ? constraints.fullName : fast_check_1.default.option(exports.arbitraryFullName, { nil: undefined }), "planCategory" in constraints
        ? fast_check_1.default.constant(constraints.planCategory)
        : payment_1.arbitraryUserLegacyPaymentPlanCategory, fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }), fast_check_1.default.date({ min: new Date("2018-01-01T00:00:00.000Z"), max: new Date() }), (0, social_1.arbitraryStarCount)(), (0, social_1.arbitraryFollowerCount)(), (0, social_1.arbitraryFollowingCount)(), (0, social_1.arbitraryDocumentCount)(), (0, social_1.arbitraryPartsCount)(), constraints.isTest !== undefined ? fast_check_1.default.constant(constraints.isTest) : fast_check_1.default.constant(true))
        .map(([uid, isAnonymous, handle, fullName, planCategory, firstDate, secondDate, starCount, followerCount, followingCount, docCount, partsCount, isTest,]) => {
        // Created at always happens before updated at (and both are already bounded to always be in the past)
        let createdAt = Math.min(firstDate.valueOf(), secondDate.valueOf());
        let updatedAt = Math.max(firstDate.valueOf(), secondDate.valueOf());
        if (constraints.createdNow) {
            createdAt = updatedAt = Date.now();
        }
        return {
            uid,
            handle,
            full_name: fullName,
            created_at: createdAt,
            updated_at: updatedAt,
            isAnonymous,
            star_count: starCount,
            follower_count: followerCount,
            following_count: followingCount,
            documents_count: docCount,
            parts_count: partsCount,
            activeProductUid: planCategory && planCategory in plan_1.PaymentPlanUids ? plan_1.PaymentPlanUids[planCategory] : undefined,
            is_test: isTest,
        };
    });
}
/**
 * Completely arbitrary non-anonymous user.
 */
function arbitraryNonAnonymousUser(constraints = {}) {
    return arbitraryUser({ ...constraints, isAnonymous: false });
}
/**
 * Completely arbitrary anonymous user.
 */
function arbitraryAnonymousUser(constraints = {}) {
    return arbitraryUser({ ...constraints, userUid: constants_1.ANON_ROLE_UID, isAnonymous: true });
}
//# sourceMappingURL=user.js.map